import { Component } from '@angular/core';

@Component({
  selector: 'mav-network-icon',
  templateUrl: './network-icon.component.html',
  styleUrls: ['./network-icon.component.scss']
})
export class NetworkIconComponent {

  constructor() { }
}
